import { LayoutBlock } from '@/layout';
import { RouteConfig } from 'vue-router';

const commonbllRouting: RouteConfig[] = [
    {
        path: 'commonbll',
        meta: { title: '业务字典' },
        component: LayoutBlock,
        redirect: '/app/commonbll/data-item',
        children: [
            {
                name: 'data-item',
                path: 'data-item',
                component: () => import(/* webpackChunkName: "admin" */ './data-item/data-item.vue'),
                meta: { title: '业务字典' },
            },
        ],
    },
];

export default commonbllRouting;
